import { Icon, IconProps } from ".";

export const Road = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M11.0556 5.38892H7.27778L3.5 18.6111H11.0556V16.7222V15.7778H12.9444V16.7222V18.6111H20.5L16.7222 5.38892H12.9444V7.2778V8.22225H11.0556V7.2778V5.38892ZM12.9444 11.0556V12.9445V13.8889H11.0556V12.9445V11.0556V10.1111H12.9444V11.0556Z" />
    </Icon>
  );
};
